import { useSearchParams } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

/** Maps `?error=` codes from the IServ callback to German banner text. */
const ERROR_MESSAGES: Record<string, string> = {
  iserv: 'Anmeldung fehlgeschlagen. Bei Problemen den IT-Admin der Schule kontaktieren.',
  overloaded: 'Der Anmelde-Service ist derzeit überlastet. Bitte versuche es gleich noch einmal.',
  not_in_group: 'Dein IServ-Konto ist nicht für den Projekt-Tracker freigeschaltet.',
  no_local_student:
    'Für deinen Account ist noch kein Schüler-Profil hinterlegt. Bitte wende dich an deine Lehrkraft.',
};

/**
 * Schüler-Login (OU-1c) — route `/student/login`. Strictly separate from the
 * teacher `LoginPage`: only an IServ button (SuS auth via SSO only, no local
 * password) and no shared layout/header.
 */
export function StudentLoginPage(): JSX.Element {
  useDocumentTitle('Schüler-Anmeldung · PA-Tracker');
  const [params] = useSearchParams();
  const errorCode = params.get('error');
  const errorMessage = errorCode ? (ERROR_MESSAGES[errorCode] ?? ERROR_MESSAGES.iserv) : null;

  return (
    <main className="container max-w-md py-12">
      <h1 className="text-3xl font-semibold">Schüler-Anmeldung</h1>
      <p className="mt-1 text-sm text-muted-foreground">Melde dich mit deinem IServ-Konto an.</p>

      {errorMessage ? (
        <div
          role="alert"
          className="mt-6 rounded-md border border-destructive/40 bg-destructive/10 px-4 py-3 text-sm text-destructive"
        >
          {errorMessage}
        </div>
      ) : null}

      <div className="mt-6">
        <Button asChild className="w-full" data-testid="student-iserv-login-button">
          <a href="/api/v1/student/auth/iserv/start">Mit IServ einloggen</a>
        </Button>
      </div>
    </main>
  );
}
